import React from 'react';
import { Button } from 'reactstrap';
import { T } from '../../../traks';

export const PaymentError = ({ setView }) => {
  const handleRetry = () => {
    setView('checkout');
  };

  return (
    <div className="error-page p-4 text-center">
      <p><T>There was an error processing your payment. Please try again.</T></p>
      <Button className="ad_new_game_button px-4 py-2" onClick={handleRetry}>
        <T>Retry</T>
      </Button>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Payment/PaymentError.js